import { useParams } from 'react-router-dom';
import CodeDetail from '../components/code-detail/CodeDetail';
import CodingGuidelines from '../components/code-detail/CodingGuidelines';
import CodeStructure from '../components/code-detail/CodeStructure';
import MedicarePricing from '../components/code-detail/MedicarePricing';
import NdcSegments from '../components/code-detail/NdcSegments';
import NdcMarketing from '../components/code-detail/NdcMarketing';
import RxNormRelationships from '../components/code-detail/RxNormRelationships';
import AIExplanation from '../components/code-detail/AIExplanation';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { useCodeDetail } from '../hooks/useCodeDetail';

const CodeDetailPage = () => {
  const { codeType, code } = useParams<{ codeType: string; code: string }>();
  const { data, isLoading, error } = useCodeDetail(codeType!, code!);

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <LoadingSpinner />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Code Not Found</h2>
          <p className="text-gray-600">
            The code you're looking for doesn't exist or has been removed.
          </p>
        </div>
      </div>
    );
  }

  const typeKey = data.codeType?.toUpperCase().replace(/-/g, '');

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="space-y-6">
        <CodeDetail code={data} />
        {typeKey === 'ICD10PCS' && <CodeStructure axisBreakdown={data.axisBreakdown} />}
        {typeKey === 'HCPCS' && <MedicarePricing pricing={data.pricing} />}
        {typeKey === 'NDC' && data.ndcSegments && <NdcSegments segments={data.ndcSegments} />}
        {typeKey === 'NDC' && <NdcMarketing marketing={data.ndcMarketing ?? null} />}
        {typeKey === 'RXNORM' && <RxNormRelationships relationships={data.relationships ?? []} codeType={data.codeType} />}
        {typeKey === 'ICD10CM' && <CodingGuidelines notes={data.notes} />}
        <AIExplanation code={data.code} description={data.description} codeType={data.codeType} />
      </div>
    </div>
  );
};

export default CodeDetailPage;